import { MDBAlert, MDBBtn, MDBContainer, MDBDatatable, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBSpinner } from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import { getAllGroupFax, getMisc } from "../../apiclients/streamsapi_bridge";
import Body from "../../components/body/BodyPage";
import SendFax from "../../components/editviews/user/SendFax";
import MainLinks from "../../components/navlinks/MainLinks";
import AddFaxGroup from "../popups/phonesystem/AddFaxGroup";
import DeleteFaxGroups from "../popups/phonesystem/DeleteFaxGroups";
import PopupLoader from "../popups/PopupLoader";
import { show_links_tab } from "../../apiclients/apiurls";
import { formattedNumber } from "../popups/phonenumbers/AddRemoveNumbers";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../components/CustomSearchUtil/CustomSearch";
import UIConstant from "../../apiclients/UIConstant";
import TabIDConstant from "../../apiclients/TabIDConstant";
function FaxGroupsLandingPage() {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [isloading, setIsloading] = useState(true);
    const [internalError, setInternalError] = useState(false);
    const [groupFaxs, setgroupFaxs] = useState([]);
    const [addFaxGroup, setAddFaxGroup] = useState(false);
    const toggleOpen = () => setAddFaxGroup(!addFaxGroup);
    const [deleteGroup, setDeleteGroup] = useState(false);
    const dtogglePopup = () => setDeleteGroup(!deleteGroup);
    const [selectedGroupId, setSelectedGroupId] = useState("");
    const [faxPhoneNums, setFaxPhoneNums] = useState([]);
    const [userList, setuserList] = useState([])
    const [groupCode, setGroupCode] = useState("");
    const [faxDomain, setfaxDomain] = useState("");
    const [primaryFax, setprimaryFax] = useState("");
    const [groupname, setgroupname] = useState("");
    const [sendFaxWarning, setSendFaxWarning] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [FaxGroupDetails, setFaxGroupDetails] = useState([]);
     const warningToggle = () => setSendFaxWarning(!sendFaxWarning);

    const [fullscreenXlModal, setFullscreenXlModal] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef)

    const sendFaxPopup = async (e, group) => {
        e.preventDefault();
        e.stopPropagation();

        console.log(sessionStorage.getItem("admin_session"));
        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            { misc: ["faxgrp_from_user", "faxgrp_from_num"], groupcode: parseInt(group.code) }
        );
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const tdata = await response.json();
        console.log("fax misc :::::::::::::: " + JSON.stringify(tdata));
        if (!tdata) {
            window.alert(`info with id  not found`);
        }
        // setFaxPhoneNums(tdata?.misc?.faxgrp_from_num ?? []);
        // setuserList(tdata?.misc?.faxgrp_from_user ?? [])
        // setGroupCode(group.code);
        // setgroupname(group.name);
        // setfaxDomain(group.domain ?? "");
        // setprimaryFax(tdata?.misc?.faxgrp_primaryfaxdid ?? "");
        // setFullscreenXlModal(!fullscreenXlModal)
        // setModalKey(prev => prev + 1);
        // const groupUsers = tdata?.misc?.faxgrp_from_user ?? [];
        // if (groupUsers.length === 0) {
        //    warningToggle();
        // } else {

            const faxParams = {
                faxNumbers: (tdata?.misc?.faxgrp_from_num ?? []),
                uniqueid: group.code,
                faxDomain: group.domain ?? "",
                userList: (tdata?.misc?.faxgrp_from_user ?? []),
                primaryFax: tdata?.misc?.faxgrp_primaryfaxdid ?? "",
                groupname: group.name,
                isActive: "tab1",
                groupFaxFlag: true,
            };
            localStorage.setItem('faxParams', JSON.stringify(faxParams));

            window.open(`/send-fax`, '_blank');
        // }
    }

    useEffect(() => {
        fetchAllFaxGroups();
    }, [])

    async function fetchAllFaxGroups() {
        try {
            setInternalError(false);
            console.log(sessionStorage.getItem("admin_session"));
            const response = await getAllGroupFax(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                TabIDConstant.FAX_GRP_LINK
            );
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            const rawData = await response.json();
            if (!rawData) {
                setInternalError(true);
            }
            console.log("fax Groups data :::::::::: " + JSON.stringify(rawData));
            setgroupFaxs(rawData?.faxgroups ?? []);
            setTimeout(() => {
                setIsloading(false);
            }, 1000);

        } catch (error) {

        }
    }

    function deletethisGroup(evntData, groupId) {
        evntData.preventDefault();
        evntData.stopPropagation();
        setSelectedGroupId(groupId)
        setDeleteGroup(true)
    }

    useEffect(()=>{
    let processdrows = [];
    groupFaxs.map((group) => {
        let phNumber = group.primary_did ? formattedNumber(group.primary_did) + "" : ""
        processdrows.push({
            groupInfo: group,
            name: group.name + "",
            // grouptype: "Fax",
            location: group.location ?? "",
            // groupMailID: group.mailid + "",
            // retries: group.retries,
            actualNumber : phNumber?.toString().replace(/[ ]/g, ''),
            primary : phNumber,
            number: group.primary_did,
            // sendagroupfax: (
            //     <>
            //         <a href="" onClick={(e) => sendFaxPopup(e, group)}>Send Fax</a>
            //     </>
            // ),
            delete: (
                <>
                    {/* <MDBIcon color="primary" className="ms-3 deleteToolTip" fas icon="times"
                        onClick={(e) => deletethisGroup(e, group.code)}
                    /> */}

                    <div className="d-flex align-items-center justify-content-center">
                        <div className="custom-hover-bg p-1 cursor-pointer sendToolTip" onClick={(e) => sendFaxPopup(e, group)}>
                            <MDBIcon fas icon="paper-plane" color="primary" className="mx-2 fs-5" />
                        </div>
                        <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => deletethisGroup(e, group.code)}>
                            <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
                        </div>
                    </div>
                </>
            ),

        })
    });
    setFilteredRows(processdrows);
    setFaxGroupDetails(processdrows)
     setDataLoaded(true);
},[groupFaxs])

    const actionData = {
        columns: [
            { label: 'Name', field: 'name', sort: true },
            // { label: 'Group Type', field: 'grouptype' },
            // { label: 'Email', field: 'groupMailID' },
            // { label: 'Retries', field: 'retries' },
            { label: 'Primary Fax Number', field: 'primary' },
            { label: 'Location', field: 'location' },
            // { label: 'Send a Group Fax', field: 'sendagroupfax', sort: false },

            { label: 'Actions', field: 'delete', sort: false },
        ],
        rows: FaxGroupDetails,
    };
    const handleManualSearch = (searchValue) => {
        setSearchValue(searchValue);
        const filtered = customSearch(FaxGroupDetails, searchValue, UIConstant.FAX_GROUP_LANDINGPAGE);

        setFilteredRows(filtered);
    };

    const navigate = useNavigate();

    const showThisInfo = (tdata) => {
        navigate("/faxgroupsdetails", {
            state: tdata.groupInfo,
        });
    }

    return (
        <React.Fragment>
            <>
                <MainLinks active={2} />
                <Body
                    tablinks={2}
                    sublink={281}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">
                                    <div className="card-header py-3 px-0">
                                        <h5 className="mb-0 ">
                                            Fax Groups
                                        </h5>
                                    </div>
                                    <div className="mt-3">
                                        <div className="faxGroupsDataTable">
                                            <div className="actionbar">
                                                {/* <MDBBtn>Create Copy</MDBBtn> */}
                                                <MDBBtn className="btn_adjust" onClick={toggleOpen}  >
                                                    <MDBIcon fas icon="plus" className="me-2" /> Add Fax Group
                                                </MDBBtn>
                                            </div>
                                               <div className='mb-2 mt-0 position-relative w-auto'>
                                                <MDBInput
                                                    label="Search"
                                                    value={searchValue}
                                                    ref={searchRef}
                                                    onChange={(e) => handleManualSearch(e.target.value)}
                                                />
                                                <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                                            </div>
                                            <MDBDatatable className="datatableSelect actioncolumnbig" sortField="Group Name" multi selectable
                                                // search
                                                key={searchValue}
                                                hover data={{
                                                    ...actionData,
                                                    rows: filteredRows
                                                }}
                                                entries={50} onRowClick={(e) => showThisInfo(e)} />
                                        </div>

                                    </div>
                                </div>
                            </section>

                            {/* <MDBModal tabIndex='-1' open={fullscreenXlModal} onClose={() => setFullscreenXlModal(false)} key={modalKey}>
                                <MDBModalDialog size='fullscreen'>
                                    <MDBModalContent className="h-100">
                                        <MDBModalHeader>
                                            <MDBModalTitle>Send Fax</MDBModalTitle>
                                            <MDBBtn
                                                type='button'
                                                className='btn-close'
                                                color='none'
                                                onClick={() => setFullscreenXlModal(false)}
                                            ></MDBBtn>
                                        </MDBModalHeader>
                                        <MDBModalBody className="sendafaxPopupBody">
                                            <MDBContainer fluid>
                                                <div className="m-auto">
                                                    <SendFax
                                                        faxPhoneNums={faxPhoneNums}
                                                        uniqueid={groupCode}
                                                        faxDomain={faxDomain}
                                                        primaryFax={primaryFax}
                                                        groupFaxFlag={true}
                                                        userList={userList}
                                                        groupname={groupname}
                                                        isActive="tab1"
                                                    />
                                                </div>
                                            </MDBContainer>
                                        </MDBModalBody>
                                        <MDBModalFooter>
                                            <MDBBtn type='button' color='secondary' onClick={(e) => setFullscreenXlModal(false)}>
                                                Close
                                            </MDBBtn>
                                        </MDBModalFooter>
                                    </MDBModalContent>
                                </MDBModalDialog>
                            </MDBModal> */}
                        </>
                    }
                />

                <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                    Delete
                </Tooltip>
                {internalError && (
                    <MDBAlert
                        open
                        className="alert-center"
                        color="danger"
                        autohide
                        position="bottom-right"
                        delay={5000}
                        onClose={() => setInternalError(false)}
                    >
                        Internal Server Error
                    </MDBAlert>
                )}
                {isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )}
                {addFaxGroup && (
                    <PopupLoader
                        title="Add Fax Group"
                        content={
                            <AddFaxGroup
                                onClose={toggleOpen}

                            />
                        }
                        onShow={setAddFaxGroup}
                        onClose={toggleOpen}

                    />
                )}
                {deleteGroup && (
                    <PopupLoader
                        title={"Remove Fax Group"}
                        content={<DeleteFaxGroups
                            groupId={selectedGroupId}
                            onClose={dtogglePopup}
                        />}
                        onShow={setDeleteGroup}
                        onClose={dtogglePopup}
                    />
                )}
                {/* {sendFaxWarning && (
                        <PopupLoader
                          size="md"
                          className="modal-xl modal-auto"
                          title="Warning"
                          content={
                            <>
                              <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                                <MDBIcon
                                  fas
                                  icon="exclamation-triangle"
                                  className="me-3 fs-5 mt-1"
                                  color="warning"
                                />
                                <div>You cannot send fax from this group as none of the user(s) in this group has the privilege to send fax. To send a fax from this group, add at least one user with the privilege to send fax.</div>
                              </div>
                              <MDBModalFooter>
                                <MDBBtn onClick={(e) => warningToggle()}>{t("ok")}</MDBBtn>
                              </MDBModalFooter>
                            </>
                          }
                          onShow={setSendFaxWarning}
                          onClose={warningToggle}
                        />
                      )} */}
                <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                    Remove
                </Tooltip>
                <Tooltip anchorSelect=".sendToolTip" place="top" className="exampleTooltip">
                    Send Fax
                </Tooltip>
            </>
        </React.Fragment>
    )
}
export default FaxGroupsLandingPage
